import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './index.css';

const Testimonials = () => {
  // 评价数据，你可以根据实际需要修改
  const testimonials = [
    {
      text: "This UK study tour truly brought me into the world beyond the classroom. Walking through the ancient colleges of Cambridge, I could almost hear the echoes of history; touching the legacy of the Industrial Revolution in museums made textbook knowledge suddenly come alive. The most unforgettable part was interacting with local students—despite the language difference, our hopes for the future felt so similar. These ten days taught me that the world is not just an outline on a map, but a three-dimensional book waiting to be opened. Thank you to our school for giving us wings to look further.",
      author: "Student from Zhejiang province, China"
    },
    {
      text: "I truly stepped into a local UK classroom, attending science lessons and participating in group debates alongside my peers. From initial nervousness to natural conversation, English is no longer just vocabulary from textbooks, but a tool for thinking and making friends. Weekends spent with my host family allowed me to experience authentic British life and cultural details firsthand. This experience not only enhanced my language skills but also taught me independence, adaptability, and empathy. A global classroom, real growth—I am deeply grateful for this unique opportunity.",
      author: "Student from Zhejiang province, China"
    },
    {
      text: 'From her showing me around the campus on the first day to working on group projects together after class, we quickly became close friends who could talk about anything. She patiently explained every detail of British classroom life, and I shared stories about school in China. On weekends, we taught each other slang words, and the language barrier just melted away in our laughter. When it was time to say goodbye, we exchanged contacts, promising to remain "cross-border sisters." This friendship taught me that genuine cultural exchange begins when hearts connect with sincerity.',
      author: "Student from Shandong province, China"
    },
    {
      text: `London, a city where history breathes through cobblestone lanes and modernitysparkles in glass skyscrapers-you've woven a tapestry of moments I'll carry forever.
      Walking across Tower Bridge at dawn, watching the Thames glint like a ribbon under the first light,I felt the weight of centuries: kings and rebels, poets and pioneers, all leaving their footprints in the same air I breathed. Strolling through Notting Hill, with its rainbow doors and the hum of street vendors,I tasted the world in a single bite of jerk chicken, heard laughter in a dozen languages, and realized this city isn't just a place-it's a living,breathing conversation between past and present.
      In the quiet of Westminster Abbey, I stood before graves of legends, humbled by how small we are, yet how loudly our stories echo. And in the chaos of Piccadilly Circus, neon and crowds swirling, I felt alive-likepart of something too big to name, but warm enough to belong to.
      Goodbye for now, London. But never really goodbye. You've stitched yourself into the fabric of my wanderings, a chapter I'll flip back to, again and again.
        `,
      author: "Student from Zhejiang province, China"
    },
    {
      text:`As a group leader, I witnessed the students' growth and transformation throughout the entire journey. From their initial unease upon arriving in the UK to actively integrating into host families and confidently participating in classroom interactions, the students' progress in independent living and cross-cultural communication was truly gratifying. During the trip, we visited museums and historical sites, combining academic learning with hands-on experience. This immersive study model proved more impactful than classroom-only learning and provided valuable insights for designing our school’s future study programs.`,
      author:`Teacher from Zhejiang province, China`
    },
    {
      text:`Participating as a team leader in the 14-day UK study tour was a dual gain for me, both in teaching and in education. During the full-immersion classes in London, the British school's teaching philosophy of "tailoring education to individual needs" and its diverse curriculum (such as STEM and creative arts) provided valuable insights for the development of our school's specialized courses. During visits to top universities like Oxford and Cambridge, interactions with international students sparked new reflections on talent cultivation. In the future, I will integrate cross-cultural educational concepts into daily teaching to better support students' all-round development.`,
      author:`Teacher from Guangdong province, China`
    },
    {
      text:`This UK study tour has given me a deeper understanding of the "classroom on the move." From London's historical landmarks to Manchester's industrial heritage, every site was filled with educational opportunities. The teaching methods in British schools, which emphasize hands-on practice and encourage innovation, as well as their focus on students' individual development, are well worth learning from. At the same time, accompanying students on cross-city travel and coordinating with host families throughout the journey has given me a clearer awareness of the importance of safety assurance and educational guidance in study tour activities. This experience will guide the optimization of our school's future study tour organization.`,
      author:`Teacher from Zhejiang province, China`
    },
  ];

  return (
    <div className="testimonials-wrapper">
      {/* <h2 className="testimonials-title">Testimonials from Teachers and Students</h2> */}
      <div className="testimonials-container">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={0}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          speed={800}
          navigation={{
            nextEl: '.testimonials-next',
            prevEl: '.testimonials-prev',
          }}
          pagination={{
            el: '.testimonials-pagination',
            clickable: true,
            bulletClass: 'testimonials-bullet',
            bulletActiveClass: 'testimonials-bullet-active'
          }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">{testimonial.text}</p>
                  <p className="testimonial-author">—{testimonial.author}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="testimonials-pagination"></div>

        {/* <div className="testimonials-navigation">
          <div className="testimonials-prev">
            <img
              src={require('../../assets/left-icon.png')}
              alt="Previous"
            />
          </div>
          <div className="testimonials-next">
            <img
              src={require('../../assets/right-icon.png')}
              alt="Next"
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Testimonials;
